<template>
  <h2 class="header-tile" :class="`text-${textAlign} ${className}`" v-html="content">
  </h2>
</template>

<script>
export default {
  name: 'tag',
  data: function () {
    return {

    }
  },
  props: {
    content: {
      type: String,
      required: true,
      default: ''
    },
    textAlign: {
      type: String,
      required: false,
      default: 'left'
    },
    className: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
  },
  created () {
  },
  destroyed () {
  },
  methods: {
  }
}
</script>
